import { history } from "app-history"

import { getProfile, getMembers, getReferences } from "api/@vt/passport"
import { getApplications } from "api/@vt/applications"
import { getAssessmentContext } from "api/@vt/assess"
import { getRegisterApplyJob, getMagicApplyJob } from "api/@vt/apply"

export const platformVtFetchProfile = () => {
  return async (dispatch) => {
    const data = await getProfile()
    if (!data.error) dispatch({ type: "VT_UPDATE_PROFILE", data })
  }
}

export const platformVtFetchMembers = () => {
  return async (dispatch) => {
    const data = await getMembers()
    if (!data.error) dispatch({ type: "VT_UPDATE_MEMBERS", data })
  }
}

export const platformVtFetchReferences = () => {
  return async (dispatch) => {
    const data = await getReferences()
    if (!data.error) dispatch({ type: "VT_UPDATE_REFERENCES", data })
  }
}

export const platformVtFetchApplications = () => {
  return async (dispatch) => {
    const data = await getApplications()
    if (!data.error) dispatch({ type: "VT_UPDATE_APPLICATIONS", data })
  }
}

export const platformVtFetchAssessmentContext = (params) => {
  return async (dispatch) => {
    const data = await getAssessmentContext(params)
    if (!data.error) dispatch({ type: "VT_UPDATE_ASSESSMENT_CONTEXT", data })
    const querypath = history.location.pathname
    const arraypath = querypath.split('/')
    arraypath.shift();
    arraypath.shift();
    const redirectpath = arraypath.join('/')
    if (data.submitted) history.push(`/assess-success/${redirectpath}`)
  }
}

export const platformVtFetchRegisterApplyJob = (params) => {
  return async (dispatch) => {
    const data = await getRegisterApplyJob(params)
    if (!data.error) dispatch({ type: "VT_UPDATE_JOB_APPLICATION", data })
  }
}

export const platformVtFetchMagicApplyJob = (params) => {
  return async (dispatch) => {
    const data = await getMagicApplyJob(params)
    if (!data.error) dispatch({ type: "VT_UPDATE_JOB_APPLICATION", data })
  }
}
